// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QLgqCQaYmBoQEQzcYl7Z{flex-grow:1;display:flex}.zUc2DEISmEynqkM2nc9K{align-items:center}.F5nO9tzDqfoUjRYTTcSn{height:20px;padding-left:8px;font-size:16px;font-style:normal;font-weight:400;line-height:24px}.F5nO9tzDqfoUjRYTTcSn::placeholder{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `QLgqCQaYmBoQEQzcYl7Z`,
	"searchWrap": `zUc2DEISmEynqkM2nc9K`,
	"search": `F5nO9tzDqfoUjRYTTcSn`
};
export default ___CSS_LOADER_EXPORT___;
